import { UserLevel } from "@edp-models/user-level.model";
import { TransactionHistory } from "@edp-models/transactions-history.model";

export interface ICelebration {
    celebrationScore: number;
    canShow: boolean;
}

export interface ILevelsState {
    userLevel: UserLevel;
    history: TransactionHistory;
    celebration: ICelebration;
}

export const initialLevelsState: ILevelsState = {
    userLevel: null,
    history: null,
    celebration: {
        canShow: false,
        celebrationScore: 0,
    },
};
